import { SearchProductAttribute } from '@winelivery-org/wl-client-sdk-js/dist/models/search';
import { capitalize } from 'lodash';
import { useTranslations } from 'next-intl';
import FilterChip from './FilterChip';

interface Props {
  subcategories: SearchProductAttribute[];
  activeSubcategory: string;
  onChange: (subcategory: string) => void;
}

export default function Filters(props: Props) {
  const t = useTranslations('bar');

  return (
    <div className="overflow-hidden -mx-4">
      <ul className="flex overflow-auto p-4 space-x-2 mb-0">
        <FilterChip
          id={null}
          name={t('subcategory.all')}
          active={!props.activeSubcategory}
          onChange={props.onChange}
        />
        {props.subcategories.map((subcategory) => (
          <FilterChip
            id={subcategory.id}
            name={capitalize(subcategory.name)}
            active={subcategory.id === props.activeSubcategory}
            onChange={props.onChange}
          />
        ))}
      </ul>
    </div>
  );
}
